import { render, staticRenderFns } from "./XentralIcon.vue?vue&type=template&id=32165a04&scoped=true"
import script from "./XentralIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./XentralIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./XentralIcon.vue?vue&type=style&index=0&id=32165a04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32165a04",
  null
  
)

export default component.exports